import { GridCol, GridContainer } from '@bob/library'
import Avatar from '@websrc/App/Components/Avatar/Avatar'
import Heading from '@websrc/App/Components/Heading/Heading'
import { mapTestimonials } from '@websrc/DataMappers/mapSpot'
import { CSSpot_Settings } from '@websrc/Typings/ContentStack'
import React, { FC } from 'react'

import SpotContentDecoration from '../SpotContentDecoration/SpotContentDecoration'
import SpotDecoration from '../SpotDecoration/SpotDecoration'
import { testimonials } from './Testimonials.css'

type SpotTestimonialsProps = {
  isTopOfPage?: boolean
  settings: CSSpot_Settings
} & ReturnType<typeof mapTestimonials>

export const SpotTestimonials: FC<SpotTestimonialsProps> = ({
  settings,
  isTopOfPage,
  headline,
  testimonial_details,
}) => {
  return (
    <SpotDecoration spotSettings={settings}>
      <GridContainer>
        <GridCol>
          <SpotContentDecoration spotSettings={settings}>
            <div className={testimonials._}>
              <Heading headline={headline} level={isTopOfPage ? 1 : 2} size={'xl'} />
              <div className={testimonials.testimonyList._}>
                {testimonial_details.map((item, index) => (
                  <div className={testimonials.testimonyList.testimonyContainer._} key={index}>
                    <p>{item.testimony}</p>
                    {item.avatar && (
                      <Avatar
                        field1={item.avatar?.field1}
                        field2={item.avatar?.field2}
                        image={item.avatar?.profile_image}
                        size={'small'}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </SpotContentDecoration>
        </GridCol>
      </GridContainer>
    </SpotDecoration>
  )
}
